import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#E2C700",
    "col1l": "#FFEF1C",
    "col1n": "#F3E200",
    "col2n": "#000000"
}
function ObjMor103({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M95.35 137q0-.3-.05-.55v1.15q.05-.3.05-.6m-.05-92.8V9.15q-.8-3.7-13.8-6.35Q67.65 0 48.05 0T14.6 2.8Q2.6 5.2 1 8.55v35.8q-.2.35-.2.75-.3.5-.5 1.1-.3.9-.3 2 0 1.85.8 3.15.1.15.2.35v36.35q-.2.35-.2.75-.3.5-.5 1.1-.3.9-.3 2 0 1.85.8 3.15.1.15.2.35v37.65q.4.8 1.4 1.55 3.05 2.8 12.2 5.05Q28.45 143 48.05 143t33.45-3.35q9.1-2.25 12.25-5.05 1.3-1 1.55-2.1V95.25q.1-.2.2-.35.8-1.3.8-3.15 0-1.1-.3-2-.2-.6-.5-1.1 0-.4-.2-.75V51.55q.1-.2.2-.35.8-1.3.8-3.15 0-1.1-.3-2-.2-.6-.5-1.1 0-.4-.2-.75z"
                    id="ObjMor103__Symbol_264_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M81.2 97.5q6.45-1.3 9.9-2.85v-.05q1.75-.8 2.75-1.65h.05l.4-.4q.45-.45.7-.95.65-.85.7-1.85-.2-.6-.5-1.1 0-.4-.2-.75V89q-.1.35-.25.7-.15.2-.35.4-3.65 3.85-11.95 5.55-.6.1-1.25.25-13.85 2.8-33.45 2.8T14.3 95.9q-3.95-.8-6.8-1.65-1.65-.65-2.9-1.3-2.65-1.35-3.5-2.85-.3-.5-.4-1.05v-1q-.2.35-.2.75-.3.5-.5 1.1.05 1 .7 1.85.35.7 1.15 1.35 1 .85 2.75 1.65.1 0 .2.05.6.25 1.3.55 3.2 1.15 8.2 2.15 13.85 2.8 33.45 2.8t33.45-2.8m14-52.55q0-.4-.2-.75v1.1q-.1.35-.25.7-3.55 4.15-12.3 5.95-.6.1-1.25.25Q67.35 55 47.75 55T14.3 52.2q-3.95-.8-6.8-1.65-1.65-.65-2.9-1.3-4.35-2.3-3.9-4.9-.2.35-.2.75-.3.5-.5 1.1.05 1 .7 1.85.35.7 1.15 1.35 1 .85 2.75 1.65.1 0 .2.05.6.25 1.3.55 3.2 1.15 8.2 2.15 13.85 2.8 33.45 2.8t33.45-2.8q6.45-1.3 9.9-2.85v-.05q1.75-.8 2.75-1.65h.05l.4-.4q.45-.45.7-.95.65-.85.7-1.85-.2-.6-.5-1.1M95 10.1v-.95q-.8-3.7-13.8-6.35Q67.35 0 47.75 0T14.3 2.8Q2.3 5.2.7 8.55v2.1q.45 1 1.85 1.9.1.05.15.1 3.35 2.1 11.6 3.75 13.85 2.8 33.45 2.8t33.45-2.8q8.05-1.65 11.45-3.65.1-.1.2-.15 1.85-1.2 2.15-2.5m-2.15-.6q0 .6-.45 1.2l-.3.3q-2.4 2.35-12.5 4.1-13.2 2.3-31.9 2.3t-31.95-2.3Q5.7 13.35 3.3 11q-.15-.15-.25-.3-.5-.6-.5-1.2 0-3.25 13.2-5.6Q29 1.6 47.7 1.6t31.9 2.3q13.25 2.35 13.25 5.6z"
                    id="ObjMor103__Symbol_262_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M90.4 93.8v.05q-3.45 1.55-9.9 2.85-13.85 2.8-33.45 2.8T13.6 96.7q-6.25-1.25-9.7-2.75-1.35-.6-2.25-1.2 0-.05-.05-.05-1.15-.85-1.6-1.75v1.6q.75 1.6 3.9 3 3.45 1.5 9.7 2.75 13.85 2.8 33.45 2.8t33.45-2.8q6.45-1.3 9.9-2.85v-.05q.95-.4 1.7-.85l.3-.2q1.2-.8 1.7-1.6.1-.15.2-.35v-1.6q-.25.5-.7 1-.4.35-.9.75-.05 0-.05.05-.45.3-1 .6t-1.25.6m3.7-44.75q.1-.15.2-.35v-1.6q-.25.5-.7 1-.4.35-.9.75-.05 0-.05.05-.45.3-1 .6t-1.25.6v.05Q86.95 51.7 80.5 53q-13.85 2.8-33.45 2.8T13.6 53q-6.25-1.25-9.7-2.75-1.35-.6-2.25-1.2 0-.05-.05-.05-1.15-.85-1.6-1.75v1.6q.75 1.6 3.9 3 3.45 1.5 9.7 2.75 13.85 2.8 33.45 2.8t33.45-2.8q6.45-1.3 9.9-2.85v-.05q.95-.4 1.7-.85l.3-.2q1.2-.8 1.7-1.6M91.4 7l.3-.3-.3-.3Q89 4.1 78.9 2.3 65.7 0 47 0T15.05 2.3Q5 4.1 2.6 6.4q-.15.15-.25.3.1.15.25.3Q5 9.35 15.05 11.1 28.3 13.4 47 13.4t31.9-2.3Q89 9.35 91.4 7z"
                    id="ObjMor103__Symbol_263_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M13.9 2.35q0-.95-2.05-1.65-2-.7-4.9-.7Q4.05 0 2 .7q-2 .7-2 1.65T2 4q2.05.7 4.95.7 2.9 0 4.9-.7 2.05-.7 2.05-1.65z"
                    id="ObjMor103__Symbol_261_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ObjMor103__Symbol_264_0_Layer0_0_FILL"
                transform="translate(266.5 188.4)"
                id="ObjMor103__col1n"
            />
            <use
                xlinkHref="#ObjMor103__Symbol_262_0_Layer0_0_FILL"
                transform="translate(266.8 188.4)"
                id="ObjMor103__col1l"
            />
            <use
                xlinkHref="#ObjMor103__Symbol_263_0_Layer0_0_FILL"
                transform="translate(267.5 192.4)"
                id="ObjMor103__col1d"
            />
            <use
                xlinkHref="#ObjMor103__Symbol_261_0_Layer0_0_FILL"
                transform="translate(337.25 196.8)"
                id="ObjMor103__col2n"
            />
        </g></g>
    )
}
export default ObjMor103
